<template>
     <v-expansion-panels class="pa-5 transparent flat elevation-0 mx-auto" flat v-model="panel" accordion focusable>
     <draggable 
        :list="questions"
                    v-bind="dragOptions"
                    @start="onDragStart"
                    @end="onDragEnd"
                    :move="onDragMove"
                    align-top
                    handle=".handle"
                   :group="{ name: 'questions', pull: 'clone', put: true }"
                  >
    <v-expansion-panel v-for="(question, index) in questions" :key="index">
     <v-hover v-slot:default="{ hover }">
      <v-expansion-panel-header @contextmenu.prevent="question.optional=!question.optional" disable-icon-rotate :class="{handle: true, 'grey--text text--lighten-1': question.optional,'grey--background background--lighten-3': question.optional}">
           <template v-slot:actions>
            <v-btn small @click.stop="deleteQuestion(question)" v-if="hover" icon><v-icon color="error">close</v-icon></v-btn>
            <v-btn small icon  v-else><v-icon>$vuetify.icons.expand</v-icon></v-btn>
          </template>
           <template v-slot="{ open }">
        <v-layout >
          <v-flex xs12 v-if="open"><b class="mr-2">{{index+1}}.</b></v-flex>
          <v-flex xs12 v-else-if="$vuetify.breakpoint.smAndDown"><b class="mr-2">{{index+1}}.</b> {{question.title}}</v-flex>
          <v-flex xs10 v-else class="ml-4"><b style="position:absolute;margin-left:-25px;">{{index+1}}.</b> {{question.title}}</v-flex>
          
          <v-flex xs2 class="text--secondary" v-if="!$vuetify.breakpoint.smAndDown && !open">
            <v-fade-transition leave-absolute>
              <span
                v-if="open"
                key="0"
              >
               
              </span>
              <span
                v-else-if="Role('lead')"
                key="1"
                class="grey--text text--lighten-1 pl-2 overline"
              >
                <span v-if="question.duration">{{question.duration}} min </span>
              </span>
               <span
                v-else
                key="1"
                class="grey--text text--lighten-1"
              >
                {{ types.filter(t => t.value == question.type)[0].label }}
              </span>
            </v-fade-transition>
          </v-flex>
        </v-layout>
        </template>
      </v-expansion-panel-header>
      </v-hover>
      <v-expansion-panel-content>
          <q-question-edit :question="question" :answer="{}" :add="true" @save="save"></q-question-edit>
      </v-expansion-panel-content>
      <v-expansion-panel-content class="px-5" v-if="false">
        <v-layout>
          <v-flex xs10>
            <v-textarea
              v-model="question.title"
              label="Vraag"
              @change="question.modified=true"
              hide-details
              auto-grow
            ></v-textarea>
        </v-flex>
        <v-flex xs2>
          <v-select
                             v-model="question.type"
                              :items="types"
                              label="Type"
                              item-text="label"
                              item-value="value"
                              @change="changeType(question)"
                            ></v-select>
        </v-flex>
        </v-layout>
         <v-layout>
          <v-flex xs10>
         <v-textarea
                      v-model="question.description"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      label="Toelichting....."
                      class="minimal transparent"
                      @change="question.modified=true"
                      
                      
                    ></v-textarea>
             </v-flex>   
              <v-flex xs2>
                      <v-switch
          v-model="question.optional"
          label="Optioneel"
          class="mt-5"
        ></v-switch>
                   </v-flex>
        </v-layout>    
                        <v-combobox
                            v-if="question.type!='text'"
                            v-model="question.options"
                            label="Opties"
                            chips
                            flat
                            dense
                            hide-details
                            small-chips
                            multiple
                            @change="question.modified=true"
                            class="mt-5"
                            append-icon
                          >
                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                  <v-chip
                                    v-bind="attrs"
                                    :input-value="selected"
                                    label
                                    small
                                    outlined
                                  >
                                    <span class="pr-2">
                                      {{ item }}
                                    </span>
                                    <v-icon
                                      small
                                      @click="parent.selectItem(item);question.modified=true"
                                    >close</v-icon>
                                  </v-chip>
                                </template>
                          </v-combobox>
                           <v-card-actions>
                             

                          <v-spacer></v-spacer>
                          <v-btn color="error" text @click="deleteQuestion(question)">Verwijderen1</v-btn>
                           <v-btn color="success" text @click="modified = true;panel=[]">Klaar</v-btn>
                          </v-card-actions>
      </v-expansion-panel-content>
    </v-expansion-panel>
    </draggable>
  </v-expansion-panels>
</template>

<script>
import draggable from "vuedraggable";
import {
  mapActions,
  mapState,
  mapMutations,mapGetters
} from 'vuex'

export default {
    components: {
        draggable
    },
    name: 'questionaire-edit',
    props: ["max", "number","isMain", "edit"],
    data: () => ({
        panel: [],
        drag: false,
        modified: false,
        active: 1,
        dragIndex: -1,
        types: [
           {label:"Tekst", value: "text"},
           {label: "Keuzelijst", value:"radio"},
           {label: "Meerkeuzelijst", value: "check"}
          ],
          question: null,
        list: []
    }),
    computed: {
          ...mapGetters('auth', ["Role"]),
         ...mapState('auth', ['authenticated',"settings"]),
         ...mapState('match', ['selected']),
         ...mapMutations('match', ['updateQuestions']),
         
         dragOptions() {
          return {
            animation: 100,
            disabled: false,
            //ghostClass: "ghost",
            pull: 'clone', put: true
          };
        },
      questions: {
            get() {
                 return this.selected.questions
            },
            set(value) {
                this.updateQuestions(value)
            }
      },
      answers () {
          return this.selected.questions
      }
    },
    destroyed(){
        
        //this.$emit('save')
    },
    mounted() {
      this.list = this.questions  
    },
    watch: {
      questions (value) {
          this.modified=true
          
      }
    },
    methods : {
      ...mapMutations('match', ["removeQuestion","deleteQuestion", "saveSelected","sortQuestions"]),
         onDragMove(e) {
            },
            onDragStart(evt) {
               this.question = this.questions[evt.oldIndex]
                this.question.drag=true
                this.dragIndex = evt.oldIndex
                this.drag = true
            },
            onDragEnd(evt) {
              this.questions[evt.newIndex].drag=false
              this.dragIndex = -1
              this.drag = false  
              this.modified=true
              this.save()
            },
        save() {
            console.log('EDIT SAVE')
          this.$emit('save')  
        },
       questionCustom (question) {
          return this.settings.questions.filter(q => q.title == question.title).length == 0
        },
        questionMark(question) {
              if (question.title && question.title.indexOf('?') == -1) return '?'
          },
        changeType(question) {
          if (question.type == 'text') delete question.options
          if (question.type == 'radio') question.options = ['JA','NEE']
          question.modified=true  
        },
      removeTag(item){
        console.log(item)
      },
       removeAt(idx) {
           var self = this
            var q = this.removeQuestion(idx)
            setTimeout(() => {
               self.panel = []
              },100)
            
            //this.$emit('delete', q[0])
          }
         
    }
}

function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, -1, arr.splice(old_index, 1)[0]);
    return arr; // for testing
}

</script>
<style>
.v-expansion-panels>div{
  width:100%;
}
.theme--light.v-expansion-panel.flat.elevation-0 .v-expansion-panel__container {
    border-top: 0px!important; 
    background-color: transparent!important; 
}


.elevation-0.flat .theme--light.v-text-field > .v-input__control > .v-input__slot:before{
    border-color: transparent!important;
}
.elevation-0.flat .theme--light.v-text-field > .v-input__control > .v-input__slot:after{
    border-color: RGBA(0,0,0,0.1);
}

.elevation-0.flat  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: transparent;
}
.ghost {
    display:none;
}
.v-stepper__label .v-btn--fab {
    position: absolute;
    right: 20px;
    margin-top: -10px;
    opacity: 0;
}
.v-stepper__step--active .v-stepper__label .v-btn--fab,
.v-stepper__step:hover .v-stepper__label .v-btn--fab{
    opacity:1;
}

.v-stepper, .v-stepper__header {
     -webkit-box-shadow: none!important; 
     box-shadow: none!important; 
}
</style>